import React from 'react';

import type {
  GradeWithScore,
  GradeScore,
} from '../../../../types/frapi-types.js';

type GradeProps = GradeWithScore;

const gradeDot = (
  grade: number,
  index: number,
  name: string,
  value?: number,
) => {
  if (value) {
    return (
      <div key={`dot-${index}-${name}`} className="dot value">
        <span>{value}</span>
      </div>
    );
  } else {
    return grade ? (
      <div key={`dot-${index}-${name}`} className="dot"></div>
    ) : (
      <div key={`dot-${index}-${name}`} className="dot grey"></div>
    );
  }
};

const renderGrades = (value: GradeScore, name: string) => {
  const grades = [0, 0, 0, 0, 0, 0].fill(1, 0, value);

  return (
    <div className="sub-grade">
      {grades.map((grade, index) => {
        if ((index === grades.length - 1 || grades[index + 1] === 0) && grade) {
          return gradeDot(grade, index, name, value);
        } else return gradeDot(grade, index, name);
      })}
    </div>
  );
};

const Grade: React.FC<GradeProps> = ({ name, value }) => {
  return (
    <div className="sub-grade-wrapper">
      <p className="name">{name} </p>
      {renderGrades(value, name)}
    </div>
  );
};

export default Grade;
